import { onConnect } from '@reatom/framework'

import { reatomRequest } from '@root/shared/lib'

import { getBlueskyPostOembedRequestAction } from './get-bluesky-post-oembed-request-action'

import type * as KnownSocialPlatformResource from '../model/known-social-platform-resource'

export const blueskyPostOembed = (options: {
  resource: KnownSocialPlatformResource.BlueskyKnownSocialPlatformResource
}) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const requestModel = reatomRequest({
    execAction: getBlueskyPostOembedRequestAction,
    prepare: () => ({ resource: options.resource }),
  })

  onConnect(requestModel, (ctx) => {
    requestModel.execute(ctx)
  })

  return { requestModel }
}
